<template>
    <div class="row payment-setting" @click="!disabled && $emit('click')" :disabled="disabled" @mouseenter="printHover = true" @mouseleave="printHover = false">
      <div class="col-3 payment-setting__icon">
        <v-icon>
            {{icon}}
        </v-icon>
      </div>
      <div class="col-9">
        <div class="payment-setting__title">
          {{title}}
        </div>
        <div class="payment-setting__subtitle">
          {{subtitle}}
        </div>
      </div>
      <span class="error-msg" v-if="printHover && disabled">
        Za dodajanje popusta počistite plačilna sredstva
      </span>
    </div>
  </template>

  <script>
  export default {
    props: {
      icon: {
        required: true,
        type: String,
      },
      title: {
        required: true,
        type: String,
      },
      subtitle: {
        required: true,
        type: String,
      },
      disabled: {
        required: false,
        type: Boolean,
      },
    },
    data () {
      return {
        printHover: false,
      }
    },
  }
  </script>

  <style lang="scss" scoped>

    .popup-body .row .payment-setting {
      color: grey;
      padding: 4px 8px;
      margin: 0;
      border: 2px solid white;
      border-radius: 5px;
      position: relative;
      user-select: none;

      &:hover {
        cursor: pointer;
        border: 2px solid grey;
      }
    }
    .payment-setting__icon {
      font-size: 37px;
    }
    .payment-setting__title {
      color: grey;
      font-size: 21px;
    }
    .payment-setting__subtitle {
      font-size: 16px;
    }

    .error-msg {
      position: absolute;
      top: 40px;
      // left: 180px;
      right: -50px;
      background: white;
      padding: 10px;
      border: 1px solid lightgray;
      border-radius: 10px;
      color: red;
      z-index: 100;
      width: 200px;
    }

    .hr-breakpoint-mobile {
      .payment-setting__icon {
        font-size: 22px;
      }
      .payment-setting__title {
        font-size: 16px;
      }
      .payment-setting__subtitle {
        font-size: 16px;
      }
    }
  </style>